import React from "react";

const TopSection = ({ data }) => {
  return (
    <div className="relative h-96 w-full">

      <img
        src={data.titleBgImage}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

      <div className="relative z-30 flex items-center justify-center h-full max-w-3xl mx-auto">
        <h1 className="text-white text-2xl md:text-3xl font-bold p-4">
          {data.title}
        </h1>
      </div>
    </div>
  );
};

export default TopSection;
